<template>
  <!-- 最新消息首页 -->
  <div class="container">
    <content-template>
      <template slot="left">本會新聞</template>
      <template slot="right">
        <li class="media-navbar"><a href="#" class="is-check" >本會新聞</a></li>
        <li class="media-navbar">
          <router-link to="/report">傳媒報導</router-link>
        </li>
        <li class="media-navbar media-navbar-none-margin">
          <router-link to="/director-logs">理事長網誌</router-link>
        </li>
        <li class="media-navbar media-navbar-none-margin">
          <router-link to="/contact-us">聯絡我們</router-link>
        </li>
      </template>
      <template slot="banner">
        <img src="./banner.jpg" class="top-banner" alt="">
      </template>
      <template slot="content">
        <div class="circle-line hidden-xs col-sm-1">
          <template v-if="articles.length > 0">
            <div class="first-circle"></div>
          </template>
          <template v-for="i in lineNum-1">
          <!--<template v-for="i in 5">-->
            <div class="line"></div>
            <div class="white-circle"></div>
          </template>
        </div>
        <div style="margin-top:65px; ">
        <template v-for="article in articles">
          <div class="news col-xs-12 col-sm-11 ">
              <div class="year-mounth">
                <div>{{changeTimeStyle(article.create_time)[0]}}</div>
                <div>{{changeTimeStyle(article.create_time)[2]}}</div>
              </div>
              <span class="the-day">{{changeTimeStyle(article.create_time)[1]}}</span>
            <div class="news-content this-title">
              <a :href="article.file_url" target="_blank">    <!-- 路由。。。指向新闻详细页面 -->
                <h4>{{article.title}}</h4>
              </a>
            </div>
          </div>
        </template>
          <!--<div class="news col-xs-12 col-sm-11 ">-->
            <!--<div class="year-mounth">-->
              <!--<div>Jul</div>-->
              <!--<div>2015</div>-->
            <!--</div>-->
            <!--<span class="the-day">22</span>-->
            <!--<div class="news-content this-title">-->
              <!--<router-link :to="{path: 'an-article'}">    &lt;!&ndash; 路由。。。指向新闻详细页面 &ndash;&gt;-->
                <!--<h4>澳門滙業盃7月「參賽學生午餐分享會」圓滿舉行</h4>-->
              <!--</router-link>-->
            <!--</div>-->
          <!--</div>-->

        </div>

      </template>
    </content-template>
  </div>
</template>
<script>
import contentTemplate from '../contentTemplate'

export default {
  components: {
    'content-template': contentTemplate
  },
  data () {
    return {
      lineNum: 1,           //多少個新聞
      pageSize: 10, //每页显示10条数据
      currentPage: 1, //当前页码
      count: 0, //总记录数
      totalPages: 0,	//总页数
      articles: []    // 文章数组
    }
  },
  methods: {
    // 根据页码获取数据
    getList: function (page) {
      var that = this
      var url = 'media/article/1'
      this.$axios.get(url)
        .then(function (response) {
          if (response.data.code === 1) {
            // console.log(response.data)
            that.articles = response.data.data
            that.lineNum = that.articles.length
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    changeTimeStyle: function (time) {
      var tArray = time.split('-')
      return tArray
    }
  },
  mounted: function () {
    this.getList()
  }
}
</script>
<style scoped>
  .container {
    padding: 0px;
  }

  .news{
    height: auto;
  }
  .year-mounth{
    display: inline-block;
    width:40px;
    height:50px;
    font-size:18px;
    font-family:PingFangSC-Regular;
    color:rgba(74,74,74,1);
    line-height:25px;
  }
  .the-day{
    width:49px;
    height:67px;
    font-size:48px;
    font-family:PingFangSC-Regular;
    color:rgba(74,74,74,1);
    /*line-height:67px;*/
  }
  .this-title{
    margin-left: 25px;
    margin-top: 10px;
  }

  .line{
    height: 75px;
  }

  /*分页*/
  .page-body {
    border: 1px solid #526ADD;
    border-radius: 100px;
  }

  .pagination li a {
    border: 0px;
    border-radius: 100px;
    cursor: pointer;
  }

  .pagination li a:hover, .pagination li a:focus {
    background: #526ADD;
    color: #ffffff;
  }

</style>



// WEBPACK FOOTER //
// src/components/mediaCenter/news.vue